import { Route, Switch, matchPath } from 'quartz-routing/react-router';
import PublicCoursePageLoadable from './loadable/PublicCoursePageLoadable';
import PublicCatalogPageLoadable from './loadable/PublicCatalogPageLoadable';
import PublicLessonPageLoadable from './loadable/PublicLessonPageLoadable';
import PublicVideoPageLoadable from './loadable/PublicVideoPageLoadable';
import CertificationOverviewPageLoadable from './loadable/CertificationOverviewPageLoadable';
import HomepageLoadable from './loadable/HomepageLoadable';
import { Paths } from './RoutingConstants';
import NotFound from './NotFound';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const routeConfig = [{
  path: Paths.HOMEPAGE,
  exact: true,
  loadable: HomepageLoadable
}, {
  path: Paths.CERTIFICATION_OVERVIEW,
  exact: true,
  loadable: CertificationOverviewPageLoadable
}, {
  path: Paths.CATALOG_PAGE,
  exact: true,
  loadable: PublicCatalogPageLoadable
}, {
  path: Paths.CATALOG_PAGE_WITH_PAGINATION,
  exact: true,
  loadable: PublicCatalogPageLoadable
}, {
  path: Paths.CATALOG_PAGE_WITH_PATH_FILTER,
  exact: true,
  loadable: PublicCatalogPageLoadable
}, {
  path: Paths.CATALOG_PAGE_WITH_PATH_FILTER_AND_PAGINATION,
  exact: true,
  loadable: PublicCatalogPageLoadable
}, {
  path: Paths.COURSE_LANDING,
  loadable: PublicCoursePageLoadable
}, {
  path: Paths.LESSON_LANDING,
  loadable: PublicLessonPageLoadable
}, {
  path: Paths.VIDEO_LANDING,
  loadable: PublicVideoPageLoadable
}];
const preloadCurrentRoute = () => {
  const path = window.location.pathname.replace(/^\/academy\/public(\/|$)/, '/');
  for (const route of routeConfig) {
    const match = matchPath(path, {
      path: route.path,
      exact: route.exact
    });
    if (match) {
      route.loadable.preload().catch(Raven.captureException.bind(Raven));
      return;
    }
  }
};
preloadCurrentRoute();
export const Routes = () => /*#__PURE__*/_jsxs(Switch, {
  children: [/*#__PURE__*/_jsx(Route, {
    component: HomepageLoadable,
    exact: true,
    path: Paths.HOMEPAGE
  }), /*#__PURE__*/_jsx(Route, {
    component: CertificationOverviewPageLoadable,
    exact: true,
    path: Paths.CERTIFICATION_OVERVIEW
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicCatalogPageLoadable,
    exact: true,
    path: Paths.CATALOG_PAGE
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicCatalogPageLoadable,
    exact: true,
    path: Paths.CATALOG_PAGE_WITH_PAGINATION
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicCatalogPageLoadable,
    exact: true,
    path: Paths.CATALOG_PAGE_WITH_PATH_FILTER
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicCatalogPageLoadable,
    exact: true,
    path: Paths.CATALOG_PAGE_WITH_PATH_FILTER_AND_PAGINATION
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicCoursePageLoadable,
    path: Paths.COURSE_LANDING
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicLessonPageLoadable,
    path: Paths.LESSON_LANDING
  }), /*#__PURE__*/_jsx(Route, {
    component: PublicVideoPageLoadable,
    path: Paths.VIDEO_LANDING
  }), /*#__PURE__*/_jsx(Route, {
    component: NotFound,
    path: "*"
  })]
});